import React from 'react';
import StyledServicesGridItem from './ServicesGridItem.style';

function ServicesGridItem({ iconUrl, text, title }) {
  return (
    <StyledServicesGridItem>
      <div className="preview-wrapper">
        <img alt={title} src={iconUrl} />
      </div>
      <h3 style={{ paddingTop: '20px', color: '#ffbf82' }}>
        {title}
      </h3>
      <p style={{ paddingTop: '10px', color: '#ffe8bf' }}>
        {text}
      </p>
    </StyledServicesGridItem>
  );
}

export default ServicesGridItem;
